// PricingPage — public, anon-readable. Re-mounts the landing-page
// Pricing section as a standalone surface so the UpgradeModal CTA
// has a real destination instead of /not-found.
//
// The component lives in src/pages/landing/Pricing.tsx and is owned
// by the landing surface; we reuse it verbatim here, threading local
// state for currency + pricing-mode so this page works without the
// landing-page parent.

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Pricing } from "../landing/Pricing.tsx";
import { type Currency } from "../landing/landing-data.ts";
import { trackEvent } from "../../conversion/trackEvent.ts";

export function PricingPage(): JSX.Element {
  const [currency, setCurrency] = useState<Currency>("GHS");
  const [pricingMode, setPricingMode] = useState<"tiers" | "bundles">("tiers");

  useEffect(() => {
    trackEvent("pricing_viewed", { surface: "pricing_page" });
  }, []);

  return (
    <div
      className="sz-landing-root"
      style={{ minHeight: "var(--vh-full)", background: "var(--bg)", paddingBottom: 80 }}
    >
      <header
        style={{
          padding: "20px 24px",
          borderBottom: "1px solid var(--border-faint)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          maxWidth: 1180,
          margin: "0 auto",
        }}
      >
        <Link
          to="/"
          style={{
            fontFamily: "var(--font-mono, monospace)",
            fontSize: 12,
            letterSpacing: "1.5px",
            textTransform: "uppercase",
            color: "var(--text-secondary)",
            textDecoration: "none",
          }}
        >
          ← STRIKZA
        </Link>
        <div style={{ display: "flex", gap: 16 }}>
          <Link
            to="/daily-acca"
            style={{
              fontSize: 12,
              fontFamily: "var(--font-mono, monospace)",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              color: "var(--text-secondary)",
              textDecoration: "none",
            }}
          >
            Daily Acca
          </Link>
          <Link
            to="/auth?intent=signup"
            style={{
              fontSize: 12,
              fontFamily: "var(--font-mono, monospace)",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              color: "var(--accent)",
              textDecoration: "none",
              padding: "6px 12px",
              border: "1px solid var(--accent)",
              borderRadius: 4,
            }}
          >
            Sign up
          </Link>
        </div>
      </header>

      <Pricing
        currency={currency}
        setCurrency={setCurrency}
        pricingMode={pricingMode}
        setPricingMode={setPricingMode}
      />

      <footer
        style={{
          maxWidth: 1180,
          margin: "0 auto",
          padding: "32px 24px 0",
          borderTop: "1px solid var(--border-faint)",
          fontFamily: "var(--font-mono, monospace)",
          fontSize: 11,
          color: "var(--text-tertiary)",
          letterSpacing: "0.5px",
          textAlign: "center",
        }}
      >
        STRIKZA never places bets · Phase 1A simulated mode · Manual placement only
      </footer>
    </div>
  );
}
